import Vue from 'vue'
import Vuex from 'vuex'
var axios = require('axios')
var _ = require('lodash');

Vue.use(Vuex)

import { getField, updateField } from 'vuex-map-fields';
import { getColorForString } from "generate-colors"

function getStoredDepartments(){
  let stored_items = JSON.parse(window.localStorage.getItem("wc_gantt_departments"));
  if (stored_items && stored_items.length){
    return stored_items
  }
  return ['2960848000001268409']
}

export default new Vuex.Store({
  state: {
    api_proxy: 'https://zoho.whitecastleroofing.com/',
    access_token: undefined,
    client_id: '1000.VX5UPU18SIQ0KA27LKWJIV7N8K0TAV',
    scope: 'ZohoCreator.report.READ,ZohoCreator.report.UPDATE',
    redirect_uri: window.location.href,
    users: undefined,
    departments: undefined,
    subproject_works: undefined,
    subproject_works_backup: undefined,
    groupBy: 'Schedule Date',
    cellheight: 40,
    cellwidth: 60,
    headerheight: 25,
    moment: require('moment'),
    selection: undefined,
    foreman_filter: [],
    department_filter: [],
    status_filter: [],
    label_filter: [],
    show_labels:true,
    show_grid:false,
    groups: {'Unscheduled':false},
    quicksearch: '',
    colors: undefined,
    saving: false,
    loading: false,
    loadmessage: '',
    selected_department: getStoredDepartments()
  },
  mutations: {
    updateField,
    setUsers(state,{users}){
      let fulluserlist = users
   
      // fulluserlist.push({Name_Concatenate: "None Listed", ID: "0"})
      
      state.users = Object.freeze(fulluserlist)

      let colormap = {}
     state.users.forEach((v)=>{
        colormap[v.ID] = 'rgb('+getColorForString(v.ID, {contrast: 75}).join(',')+')'

      })
      colormap[0] = '#cccccc'
      state.colors = Object.freeze(colormap)
      // state.
      // console.log('colors',state.colors)
      
    },
    setloadmessage(state,message){
      state.loadmessage = message
    },
    setSaving(state,status){
      state.saving = status
    },
    setLoading(state,status){
      state.loading = status
    },
    setDepartments(state,{departments}){
      state.departments = Object.freeze(departments)
      // departments.push({Department_Name: "None Listed", ID: "0"})
      // state.departments
    },
    setSchedule(state,data){
      // data = data.map(d=>{
      //   d.Sub_Project_Work_Name_SPW = Object.freeze(d.Sub_Project_Work_Name_SPW)
      //   d.Sub_Project_SPW = Object.freeze(d.Sub_Project_SPW)
      //   return d
      // })
      data = data.map(r=>{
        console.log(r)
   
        r.schedule_labels = (r.schedule_labels ? JSON.parse(r.schedule_labels) : [])
        return r
      })
      data = _.uniqBy(data,"ID")
      
      state.subproject_works = data
      state.subproject_works_backup = Object.freeze(_.cloneDeep(data))
    },
    toggle_group(state,group){
      // console.log('toggle group', group)
      // console.log('keys',Object.keys(state.groups))
      if (Object.keys(state.groups).includes(group)){
        // console.log('in group!')
        state.groups[group] = !state.groups[group]
      }
      else {
        Vue.set(state.groups,group,false)
      }
    },
    clearChanges(state,{itemID}){

        state.subproject_works = state.subproject_works.map(s=>{
            if (!itemID || itemID == s.ID){
              s = _.cloneDeep(state.subproject_works_backup.find(r=>{return r.ID == s.ID}))
            }            
          return s
        })
    }
  },
  getters: {
    getField,
    schedule(state){
      if (!state.subproject_works){
        return undefined
      }
      // Apply filters
      let filtered_spws = state.subproject_works

      if (state.quicksearch){
        let uppersearch = state.quicksearch.toUpperCase()
        filtered_spws = filtered_spws.filter(s=>{
          return s.Sub_Project_Work_Name_SPW.toUpperCase().includes(uppersearch) || (s.Foreman_SPW && s.Foreman_SPW.display_value.toUpperCase().includes(uppersearch)) || (s.Department_in_Charge_SPW && s.Department_in_Charge_SPW.display_value.toUpperCase().includes(uppersearch))
        })
      }

      if (state.foreman_filter.length){
        let filters = state.foreman_filter.map(f=>f.ID)
        filtered_spws = filtered_spws.filter(s=>{
          return filters.includes(s.Foreman_SPW.ID)
        })
      }

      if (state.status_filter.length){

        filtered_spws = filtered_spws.filter(s=>{
          return state.status_filter.includes(s.Schedule_SPW)
        })
      }

      if (state.department_filter.length){
        let filters = state.department_filter.map(f=>f.ID)
        filtered_spws = filtered_spws.filter(s=>{
          return filters.includes(s.Department_in_Charge_SPW.ID)
        })
      }
      
      if (state.label_filter.length){
        filtered_spws = filtered_spws.filter(row=>{
          return row.schedule_labels.some(l=>{return state.label_filter.includes(l)})
        })
      }

      let spw_map =  filtered_spws.map(s=>{
        let obj = {}
        obj['spw'] = s
        if (!s.Start_Date_SPW){
          obj['days'] = 0
        }
        else if (!s.End_Date_SPW){
          obj['days'] = 1
        }
        else{
          // console.log(s)
          let d = state.moment(s.End_Date_SPW).diff(state.moment(s.Start_Date_SPW),'days')
          obj['days'] = (d ? d : 1)
      
        }

        return obj
      })

      return _.sortBy(spw_map, [r=>{
        if(r.spw.Start_Date_SPW){
          return state.moment(r.spw.Start_Date_SPW)
        }
        else{
          return undefined
        }
      },r=>{
        return r.spw.schedule_labels
      }])
    },
    allLabels(state){
      console.log('spws',state.subproject_works)
      if (!state.subproject_works){
        return []
      }
      else{
      let labels = []
      state.subproject_works.forEach(s=>{
        s.schedule_labels.forEach(l=>{
          labels.push(l)
        })
      })
      return [... new Set(labels)]
      }

    },
    unique_users(state){
      if (!state.users){
        return []
      }
      let ids = state.subproject_works.map(s=>(s.Foreman_SPW ? s.Foreman_SPW.ID : undefined))
   
      return state.users.filter(u=>{
        return ids.includes(u.ID)
      })
    },
    width_to_today(state,getters){
      let w = state.moment().diff(state.moment(getters.min_date),'days')*state.cellwidth
      return w 
      
    },
    unique_departments(state){
   
      let ids = state.subproject_works.map(s=>s.Department_in_Charge_SPW.ID)
   
      return state.departments.filter(u=>{
        return ids.includes(u.ID)
      })
    },
    min_date(state, getters){
      let start_dates = getters.schedule.map(d=>{return d.spw.Start_Date_SPW}).filter(d=>d).concat(getters.schedule.map(d=>{return d.spw.End_Date_SPW}).filter(d=>d))
      // let items_with_dates = getters.schedule.filter(d=>{return d.spw.Start_Date_SPW})
      return  state.moment(_.minBy(start_dates, function(o) { return  state.moment(o); }));
    },
    max_date(state, getters){
      let end_dates = getters.schedule.map(d=>{return d.spw.End_Date_SPW}).filter(d=>d).concat(getters.schedule.map(d=>{return d.spw.Start_Date_SPW}).filter(d=>d))
      // let items_with_dates = getters.schedule.filter(d=>{return d.spw.Start_Date_SPW})
      return  state.moment(_.maxBy(end_dates, function(o) { return  state.moment(o); }));
    },
    grid_width(state,getters){
      return (state.cellwidth * getters.date_range.length)
    },
    days(state, getters){
      return getters.min_date.diff(getters.max_date,'days')
    },
    date_range(state,getters){
      var dateArray = [];
      var currentDate = state.moment(getters.min_date);
      var stopDate = state.moment(getters.max_date);
      while (currentDate <= stopDate) {
        let istoday = currentDate.isSame(state.moment(), 'day');
        dateArray.push( {value: state.moment(currentDate), today: istoday} )
        currentDate = state.moment(currentDate).add(1, 'days');
      }
      return dateArray;
    },
    groupedSchedule(state, getters){
      if (state.groupBy == 'Department'){
        return _.groupBy(getters.schedule,(r)=>{
          if (typeof r.spw.Department_in_Charge_SPW == 'undefined'){
            return undefined
          }
          return state.departments.find(d=>{
            return d.ID == r.spw.Department_in_Charge_SPW.ID
          }).Department_Name
        })
      }
      else if (state.groupBy == 'Foreman'){
        return _.groupBy(getters.schedule,(r)=>{
          console.log('r',r)
          if (!r.spw.Foreman_SPW){
            return undefined
          }
          let usermatch =  state.users.find(d=>{
            return d.ID == r.spw.Foreman_SPW.ID
          })
          console.log(usermatch)
          return usermatch.Name_Concatenate
        })

      }

      else if (state.groupBy == 'Status'){
        return _.groupBy(getters.schedule,(r)=>{

            return r.spw.Schedule_SPW

      })
    }
      else if (state.groupBy == 'Schedule Date'){
        let dateschedule = _.groupBy(getters.schedule,(r)=>{
          if (r.spw.Start_Date_SPW ){
            return 'All Scheduled'
          }
          else{
            return 'Unscheduled'
          }
      })
      return _(dateschedule).toPairs().sortBy(0).fromPairs().value()
      }
    },
    modifications(state){
      if (!state.subproject_works){
        return undefined
      }
      return state.subproject_works.map(spw=>{
        let backup = state.subproject_works_backup.find(b=>b.ID==spw.ID)
        let modifications = {}
        let patchdata = {}
        if (spw.Start_Date_SPW != backup.Start_Date_SPW){
          modifications['Start_Date_SPW'] = {new: spw.Start_Date_SPW, old: backup.Start_Date_SPW}
          patchdata['Start_Date_SPW'] = (spw.Start_Date_SPW ? state.moment(spw.Start_Date_SPW).format('MM-DD-YYYY') : "")
        }
        if (spw.End_Date_SPW != backup.End_Date_SPW){
          modifications['End_Date_SPW'] = {new: spw.End_Date_SPW, old: backup.End_Date_SPW}
          patchdata['End_Date_SPW'] = (spw.End_Date_SPW ? state.moment(spw.End_Date_SPW).format('MM-DD-YYYY') : "")
        }
        if (_.get(spw, 'Foreman_SPW.ID',"") != _.get(backup, 'Foreman_SPW.ID',"")){
          modifications['Foreman_SPW'] = {new: _.get(spw, 'Foreman_SPW.ID',""), old: _.get(backup, 'Foreman_SPW.ID',"")}
          patchdata['Foreman_SPW'] = _.get(spw,'Foreman_SPW.ID',"")
        }
        if (_.get(spw,'Department_in_Charge_SPW.ID',"") != _.get(backup,'Department_in_Charge_SPW.ID',"")){
          modifications['Department_in_Charge_SPW'] = {new: _.get(spw,'Department_in_Charge_SPW.ID',""), old: _.get(backup,'Department_in_Charge_SPW.ID',"")}
          patchdata['Department_in_Charge_SPW'] = _.get(spw,'Department_in_Charge_SPW.ID',"")
        }
        if (spw.Schedule_SPW != backup.Schedule_SPW){
          modifications['Schedule_SPW'] = {new: spw.Schedule_SPW, old: backup.Schedule_SPW}
          patchdata['Schedule_SPW'] = spw.Schedule_SPW 
        }
        if (JSON.stringify(spw.schedule_labels) != JSON.stringify(backup.schedule_labels)){
          modifications['schedule_labels'] = {new: spw.schedule_labels, old: backup.schedule_labels}
          patchdata['schedule_labels'] = JSON.stringify(spw.schedule_labels) 
        }
        return {spw:spw, modifications, patchdata}
      }).filter(mod => {
        return Object.keys(mod.modifications).length})
    }
  },
  actions: {
    authorize({state}){
      window.location.href = `https://accounts.zoho.com/oauth/v2/auth?response_type=token&client_id=${state.client_id}&scope=${state.scope}&redirect_uri=${state.redirect_uri}`
    },
    bootstrapApp({dispatch}){
      let getDepartmentPromise = dispatch('getDepartments')
      let getUserPromise = dispatch('getUsers')
      // let getSchedulePromise = dispatch('getSchedule')

      // let getSchedulePromise = dispatch('getSchedule')
      return Promise.all([getDepartmentPromise,getUserPromise]).then(results=>{
        results
        return dispatch('getSchedule')
      })
    },
    // Departments
    getDepartments({state, commit}){
      commit('setloadmessage','Getting Department Data')
      var config = {
        method: 'get',
        url: state.api_proxy + 'https://creator.zoho.com/api/v2/danehansen/wc-projects/report/All_Departments',
        params: {
        },
        headers: { 
          'Authorization': 'Zoho-oauthtoken '+state.access_token        }
      };

      return axios(config).then(function (response) {
        // console.log('response from departments',response)
        commit('setDepartments',{departments:response.data.data})
      })
      .catch(function (error) {
        console.log(error)
      });
    },
    // Users
    getUsers({state, commit}){
      commit('setloadmessage','Getting User Data')
      var config = {
        method: 'get',
        url: state.api_proxy + 'https://creator.zoho.com/api/v2/danehansen/wc-projects/report/User_List',
        params: {
          from:0
        },
        headers: { 
          'Authorization': 'Zoho-oauthtoken '+state.access_token        }
      };

      async function recursivefetch(){
        // console.log('recursive fetch start')
      let responses = []
      let keepgoing = true
      while (keepgoing){
          // console.log('limit',config.params.from)
          let finalresult = false
          await axios(config)
              .then(function (response) {
                  responses = [...responses, ...response.data.data]
                  if (response.data.data.length==200){
                      // console.log('fetch more')
                      config.params.from += 200
                  }
                  else{
                      // console.log('got last user')
                      finalresult = true 
                  }
                  return response.data
              })
              .catch(function (error) {
                finalresult = true
                  console.log(error)
              });  
              if (finalresult){
                  return responses
              }
      }
    }
    recursivefetch().then(data=>{
      // console.log('all users then callback',data)
      console.log('GOT ALL USERS',data)
      commit('setUsers',{users:data})
    })
    },
    getSchedule({state, commit}){
      commit('setloadmessage','Getting Schedule Data')
      commit('setLoading',true)

      let criteria_string = `Schedule_SPW != "Complete"`
      console.log('selected department', JSON.stringify(state.selected_department))
      if (state.selected_department.length){
        criteria_string = criteria_string + ' && Department_in_Charge_SPW.ID == ' + JSON.stringify(state.selected_department)
      }
      console.log(criteria_string)


      var config = {
        method: 'get',
        url: state.api_proxy + 'https://creator.zoho.com/api/v2/danehansen/wc-projects/report/Subproject_Work_Gantt',
        params: {
          criteria: criteria_string,
          from: 0
        },
        headers: { 
          'Authorization': 'Zoho-oauthtoken '+state.access_token        
        }
      };

      async function recursivefetch(){
        let responses = []
        let keepgoing = true
        while (keepgoing){
          let finalresult = false
          await axios(config)
            .then(function (response) {
              console.log(response.data.data.length)
              commit('setloadmessage',`Retrieved ${responses.length} items.`)
              responses = [...responses, ...response.data.data]
                    if (response.data.data.length>197){
                        // console.log('fetch more')
                        config.params.from += 200
                    }
                    else{
                        // console.log('got last user')
                        finalresult = true 
                    }
                    return response.data
              // commit('set_sub_project_works',response.data.data)
              // commit('setLoading',false)
            })
            .catch(function (error) {
              console.log(error)
              // commit('set_sub_project_works',[])
              // commit('setLoading',false)
            });
            if (finalresult){
              return responses
          }
        }
      }

      return recursivefetch().then(data=>{
        // console.log('all users then callback',data)

        // console.log('final data',data)
        commit('setloadmessage','Got Schedule Data')
        commit('setLoading',false)
        commit('setSchedule',data)
        // commit('set_sub_project_works',data)
 
      })
 
      // return axios(config).then((response)=>{
      //   commit('setloadmessage','Getting Unscheduled Items')
      //   let scheduleddata = response.data.data
      //   // console.log('first schedule data',scheduleddata)
      //   config.params.criteria = `Schedule_SPW != "Complete" &&  Start_Date_SPW == null)` 
      //   return axios(config).then((response2)=>{
      //     commit('setloadmessage','Got Schedule Data')
      //     commit('setLoading',false)
      //     scheduleddata = scheduleddata.concat(response2.data.data)
      //     // console.log('schedule final',scheduleddata)
      //     commit('setSchedule',scheduleddata)
      //   })
        
      // })
     
    },
    saveToZoho({state, commit, getters, dispatch}){

      function updateSpw(id,data){
        if (!id){
          return undefined
        }
        var config = {
          method: 'patch',
          url: state.api_proxy+'https://creator.zoho.com/api/v2/danehansen/wc-projects/report/All_Sub_Project_Work/'+id,
          params: {
          },
          headers: { 
            'Authorization': 'Zoho-oauthtoken '+state.access_token        
          },
          data: data
        };
        return axios(config)
        .then(function (response) {
          // console.log(response.data)
          return response.data;
        })
        .catch(function (error) {
          console.log(error)
        });
      }
    
  commit('setSaving',true);

  let promiselist = []
  let changelist = getters.modifications
  changelist.forEach(item=>{

    promiselist.push(updateSpw(item.spw.ID,{data:item.patchdata}))
  })

  return Promise.allSettled(promiselist).then(results=>{
    commit('setSaving',false);
    let finalresults = results.map(r=>{return r.value})
    dispatch('getSchedule')
    return finalresults
  })

    },
  },
  modules: {
  }
})
